import revealer from 'jquery-revealer';
import themeUtils from '../themeUtils';

export default class StaticNavigation {
  constructor(el) {
    this.el = el;
    this.$el = $(this.el);

    this.$navigationWrapper = this.$el.find('[data-navigation-wrapper]');
    this.$navigationContent = this.$el.find('[data-navigation-content]');
    this.$body = $(document.body);
    this.$height = $(window).height();

    this.layoutChange = this.layoutChange.bind(this);
    this.setupNavigation();
  }

  _bindEvents() {
    $('.mega-nav-list li a', this.$el ).on('mouseover', event => this.onListItemMouseover(event));
    $('.mega-nav-list a', this.$el).on('mouseleave', event => this.useDefaultImage(event));
    $('.has-dropdown [data-subnav-toggle]', this.$el).on('click', event => this.toggleNavTier(event));
    $('[data-header-nav-toggle]', this.$el).on('click', event => this.handleMobileNavigationToggle(event));
    $(window).on('resize.navigation', themeUtils.debounce(this.layoutChange, 500));

    $('.has-mega-nav').on('mouseenter', ((event) => {
      if (themeUtils.isSmall()) {
        return;
      }
      this.swapMegaNavImages($('.mega-nav-image img', event.currentTarget));
      const $dropdown = $(event.currentTarget).children('.mega-nav');
      const $navigationSubmenuToggle = $(event.currentTarget).find('.navigation-submenu-toggle');
      $dropdown.revealer('show');
      $navigationSubmenuToggle.attr('aria-expanded', true);
    }));

    $('.has-mega-nav').on('mouseleave', ((event) => {
      if (themeUtils.isSmall()) {
        return;
      }

      const $dropdown = $(event.currentTarget).children('.mega-nav');
      const $navigationSubmenuToggle = $(event.currentTarget).find('.navigation-submenu-toggle');
      $dropdown.revealer('hide');
      $navigationSubmenuToggle.attr('aria-expanded', false);
    }));

    $('.has-dropdown').on('mouseenter', ((event) => {
      const $dropdown = $(event.currentTarget).children('.navigation-submenu');
      const $navigationSubmenuToggle = $(event.currentTarget).find('.navigation-submenu-toggle');
      $dropdown.revealer('show');
      $navigationSubmenuToggle.attr('aria-expanded', true);
    }));

    $('.has-dropdown').on('mouseleave', ((event) => {
      if (themeUtils.isSmall()) {
        return;
      }

      const $dropdown = $(event.currentTarget).children('.navigation-submenu');
      const $navigationSubmenuToggle = $(event.currentTarget).find('.navigation-submenu-toggle');
      $dropdown.revealer('hide');
      $navigationSubmenuToggle.attr('aria-expanded', false);
    }));

    $('.navigation-submenu').on('revealer-animating', ((event) => {
      if (themeUtils.isSmall()) {
        return;
      }

      const $dropdown = $(event.currentTarget);

      if (!$dropdown.hasClass('animating-in')) {
        return;
      }

      $dropdown.removeClass('navigation-submenu-open-left');
      $dropdown.css('opacity', 0);
      $dropdown.css('display', 'block');
      const navigationWidth = this.$navigationWrapper.width();
      const offset = $dropdown.offset();

      if ((offset.left + 200) > navigationWidth) {
        $dropdown.addClass('navigation-submenu-open-left');
      }

      $dropdown.css('opacity', '');
      $dropdown.css('display', '');
    }));

  }

  _unbindEvents() {
    $('.mega-nav-list li a', this.$el ).off('mouseover');
    $('.mega-nav-list a', this.$el).off('mouseleave');
    $('.has-dropdown [data-subnav-toggle]', this.$el).off('click');
    $('[data-header-nav-toggle]', this.$el).off('click');
    $(window).off('resize.navigation');
    $('.has-mega-nav').off('mouseenter');
    $('.has-mega-nav').off('mouseleave');
    $('.has-dropdown').off('mouseenter');
    $('.has-dropdown').off('mouseleave');
    $('.navigation-submenu').off('revealer-animating');
  }

  onSectionUnload(e) {
    this.unload();
  }

  layoutChange(event) {
    this._bindEvents();
    this.setupNavigation();

    // This is needed to explicitly check window height for Android devices
    if ($(window).height() !== this.$height) {
      if (!themeUtils.isLessThanMedium()) {
        const $navigationSubmenuToggle = $(event.currentTarget).find('.navigation-submenu-toggle');
        this.$navigationWrapper.removeClass('visible');
        $navigationSubmenuToggle.attr('aria-expanded', false);
        this.toggleMobileNavigation($navigationSubmenuToggle, 'close');
      }
    }
  }

  unload() {
    this.toggleMobileNavigation('close');
    this._unbindEvents();
  }

  _onSectionLoad(e) {
    this.setupNavigation();
  }

  setupNavigation() {
    if (!themeUtils.isLessThanLarge()) {
      this.$navigationWrapper
        .detach()
        .insertAfter('[data-header-branding]');

      this.$navigationContent
        .removeClass('navigation-mobile')
        .addClass('navigation-desktop');
      this.$navigationContent.find('li[data-mega-nav="true"]')
        .removeClass('has-dropdown')
        .addClass('has-mega-nav');
    } else {
      this.$navigationWrapper
        .detach()
        .insertAfter('[data-header-main]');

      this.$navigationContent
        .removeClass('navigation-desktop')
        .addClass('navigation-mobile');
      this.$navigationContent.find('li[data-mega-nav="true"]')
        .removeClass('has-mega-nav')
        .addClass('has-dropdown');
    }
    this._bindEvents();
  }

  onListItemMouseover(e) {
    this.swapMegaNavImages(e.currentTarget.parentNode);
  }

  swapMegaNavImages(target) {
    const image = $(target).data('image');
    const imageAlt = $(target).data('image-alt');

    if (image && (image !== '')) {
      $(target)
        .closest('.mega-nav')
        .find('.mega-nav-image img')
        .attr('src', image)
        .attr('srcset', '')
        .attr('alt', imageAlt);
    }
  }

  handleMobileNavigationToggle(event) {
    const $navigationSubmenuToggle = $(event.currentTarget).find('.navigation-submenu-toggle');

    this._unbindEvents();

    if (this.$body.hasClass('mobile-nav-open')) {
      this.toggleMobileNavigation($navigationSubmenuToggle, 'close');
    } else {
      this.toggleMobileNavigation($navigationSubmenuToggle, 'open');
    }

    this._bindEvents();
  }

  toggleMobileNavigation($navigationSubmenuToggle, direction) {
    if (direction === 'open') {
      this.$body.addClass('mobile-nav-open lock-scroll');
      this.$navigationContent.addClass('visible');
      this.$navigationWrapper.addClass('visible background');
      $navigationSubmenuToggle.attr('aria-expanded', true);
      this.setTierHeight();
    } else if (direction === 'close') {
      this.$navigationContent.removeAttr('style');
      this.$body.removeClass('mobile-nav-open lock-scroll');
      this.$navigationContent.removeClass('visible');
      $navigationSubmenuToggle.attr('aria-expanded', false);
      this.$navigationWrapper.removeClass('visible background');
      $navigationSubmenuToggle.attr('aria-expanded', false);

      // Close opened menus on navigation close
      this.$navigationContent
        .find('.has-dropdown-open')
        .removeClass('has-dropdown-open')
        .find('.navigation-submenu-visible')
        .removeClass('navigation-submenu-visible');
    }
  }

  toggleNavTier(e) {
    if (this.$navigationContent.hasClass('navigation-mobile')) {
      e.preventDefault();
    }

    const $target = $(e.currentTarget);
    const $trigger = $target.closest('a');
    const $parentEl = $trigger.parent('li');
    const $targetLinkList = $(`ul[data-linklist='${$trigger.data('linklist-trigger')}']`, this.$el);

    if ($parentEl.hasClass('has-dropdown-open')) {
      this.closeNavTier({
        $parentEl,
        $targetLinkList,
      });
      $target.attr('aria-expanded', 'false');
    } else {
      this.closeSiblingTiers($parentEl);
      this.openNavTier({
        $parentEl,
        $targetLinkList,
      });
      $target.attr('aria-expanded', 'true');
    }
  }

  closeSiblingTiers($openMenu) {
    $openMenu.siblings('.has-dropdown-open').each((index, el) => {
      const $parentEl = $(el);
      const $targetLinkList = $parentEl.find('.navigation-submenu-visible');

      this.closeNavTier({ $parentEl, $targetLinkList });
    });
  }

  openNavTier(options) {
    const { $parentEl, $targetLinkList } = options;

    $targetLinkList.addClass('navigation-submenu-visible');
    $parentEl.addClass('has-dropdown-open');

    this.setTierHeight();
  }

  closeNavTier(options) {
    const { $parentEl, $targetLinkList } = options;

    $targetLinkList
      .removeClass('navigation-submenu-visible')
      .find('.navigation-submenu-visible')
      .removeClass('navigation-submenu-visible');

    $parentEl
      .removeClass('has-dropdown-open')
      .find('.has-dropdown-open')
      .removeClass('has-dropdown-open');

    this.setTierHeight();
  }

  setTierHeight() {
    this.$navigationContent.css({
      'overflow-y': 'scroll',
      height: '100%',
    });
  }

  useDefaultImage(e) {
    const megaNavImage = $(e.target)
      .closest('.mega-nav')
      .children('.mega-nav-image img');
    megaNavImage.attr('src', megaNavImage.data('image')).attr('alt', megaNavImage.data('alt'));
  }
}
